import React from 'react'
import { useField } from 'formik'
import { MultiSelect } from 'primereact/multiselect'
import { useTranslation } from 'react-i18next'

const sharedPt = lang => ({
  header: { className: 'p-[10px]' },
  list: { className: 'p-[5px] !py-0' },
  input: {
    className: '!w-full !p-1.5 bg-gray-100 border border-gray-300',
    box: { className: '!border !border-gray-300 !bg-gray-100' }
  },
  dropdownicon: { className: 'h-[12px] w-[12px]' },
  item: { className: 'capitalize' },
  label: { className: 'p-[2px] flex items-center' },
  filterinput: { className: 'h-[30px] !text-[12]' },
  input: { className: 'text-[12px] !p-[6px]' },
  itemgrouplabel: {
    className: '!text-primary !font-semibold capitalize text-[12px]'
  },
  itemlabel: { className: '!text-[12px]' },
  clearicon: {
    className: `!text-dark ${lang === 'en' ? '!right-[2.3rem] !left-auto' : '!left-[2.3rem] !right-auto'}`
  }
})

const FormikMultiSelectField = ({
  label = '',
  name = '',
  className = '',
  options = [],
  optionLabel = 'label',
  optionValue = 'value',
  placeholder,
  parentClass = '',
  filter = false,
  display = 'chip',
  filterPlaceholder = 'Search',
  ...props
}) => {
  const [field, meta] = useField(name)
  const { i18n } = useTranslation()

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      <label htmlFor={name} className='input-label'>
        {label}
      </label>
      <MultiSelect
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        placeholder={placeholder}
        filter={filter}
        value={Array.isArray(field.value) ? field.value : []}
        filterPlaceholder={filterPlaceholder}
        display={display}
        className={`multiselect !w-full ${className} input-field !p-0`}
        pt={sharedPt(i18n.language)}
        {...field}
        {...props}
      />
      {meta.error && meta.touched && (
        <p className='text-sm text-red-500'>{meta.error}</p>
      )}
    </div>
  )
}

// Standalone component
const StandaloneDropdownField = ({
  label = '',
  options = [],
  optionLabel = 'label',
  optionValue = 'value',
  parentClass = '',
  placeholder = '',
  className = '',
  defaultValue = '',
  value = null,
  filter = false,
  ptOptions = null,
  filterPlaceholder = 'Search',
  display = 'chip',
  handleChange = () => { },
  ...props
}) => {
  const { i18n } = useTranslation()
  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`}>
      {label && (
        <label htmlFor='standalone-date-picker' className='input-label'>
          {label}
        </label>
      )}
      <MultiSelect
        options={options}
        optionLabel={optionLabel}
        optionValue={optionValue}
        placeholder={placeholder}
        value={Array.isArray(value) ? value : []}
        filter={filter}
        display={display}
        filterPlaceholder={filterPlaceholder}
        onChange={handleChange}
        className={`!w-full input-field !p-0 ${className}`}
        pt={ptOptions ? ptOptions : sharedPt(i18n.language)}
        {...props}
      />
    </div>
  )
}

// wrapper
const MultiSelectField = props => {
  const { useFormik = true } = props

  if (useFormik) {
    return <FormikMultiSelectField {...props} />
  }

  return <StandaloneDropdownField {...props} />
}

export default MultiSelectField
